/*========GET MSG========*/
export const GET_MSG_SUCCESS   = 'GET_MSG_SUCCESS';
export const GET_MSG_FAIL      = 'GET_MSG_FAIL';

/*========GET FRIEND========*/
export const GET_FRIEND_SUCCESS   = 'GET_FRIEND_SUCCESS';
export const GET_FRIEND_FAIL      = 'GET_FRIEND_FAIL';